import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { convertCurrency, formatNumber } from "../../../utils/helper";
import AmountInHandCard from "./AmountInHandCard";

const IncomeExpenesDetails = () => {
  const dashboardData = useSelector((state) => state.dashboard.dashboardData);
  const currencySelected = useSelector(
    (state) => state.currency.currencySelected
  );
  const exchangeRates = useSelector((state) => state.currency.exchangeRates);
  const { t } = useTranslation();
  return (
    <>
      <div className="col-12 income-expanse-card">
        <div className="row mx-0 income-card common-statics-card">
          <div className="statics-details-with-icon">
            <div className="statics-icon">
              <img
                src="/assets/images/icons/income-green-icon.svg"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="statics-name-title">{t("dashboard.income")}</div>
          </div>
          <div className="statics-price-div">
            <h5 className="mb-0">
              <small>{currencySelected}</small>{" "}
              {formatNumber(
                convertCurrency(
                  dashboardData?.totalIncome,
                  exchangeRates,
                  currencySelected
                ) || 0
              )}
            </h5>
          </div>
        </div>
        <div className="row mx-0 expenses-card common-statics-card">
          <div className="statics-details-with-icon">
            <div className="statics-icon">
              <img
                src="/assets/images/icons/expense-gray-icon.svg"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="statics-name-title">{t("dashboard.expenses")}</div>
          </div>
          <div className="statics-price-div">
            <h5 className="mb-0">
              <small>{currencySelected}</small>{" "}
              {formatNumber(
                convertCurrency(
                  dashboardData?.totalExpense,
                  exchangeRates,
                  currencySelected
                ) || 0
              )}
            </h5>
          </div>
        </div>
        <AmountInHandCard />
      </div>
    </>
  );
};

export default IncomeExpenesDetails;
